import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { deleteByValidationKey } from "../../../../../stateManager/store/formCreation_v2/actions";

import { ReactComponent as DeleteIcon } from "../../../../../assets/svg/solobuilder/delete.svg";
import { ReactComponent as SaveIcon } from "../../../../../assets/svg/solobuilder/save.svg";
import { ReactComponent as EditIcon } from "../../../../../assets/svg/solobuilder/edit.svg";

interface IProps {
  option: any;
  options: any;
  updateOptions: (data: any, key: string) => void;
  canEdit?: boolean;
}
const validationTypeList = [
  {
    label: "Min",
    value: "min",
    validType: "Number",
  },
  {
    label: "Max",
    value: "max",
    validType: "Number",
  },
  {
    label: "Min Length",
    value: "minlength",
    validType: "Input",
  },
  {
    label: "Max Length",
    value: "maxlength",
    validType: "Input",
  },
  {
    label: "Pattern",
    value: "pattern",
    validType: "All",
  },
];
export const ListValidationValue = (props: IProps) => {
  const { canEdit = true } = props;
  const option = props.option;
  const options = props.options;

  const [isEdit, setEdit] = useState(false);
  const [label, setLabel] = useState("");
  const [value, setValue] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [ErrMessage, setErrMessage] = useState("");
  const dispatch = useDispatch();
  useEffect(() => {
    for (let i in validationTypeList) {
      if (validationTypeList[i].value === option) {
        setLabel(validationTypeList[i].label);
      }
    }
    setValue(options[option]);
    setErrorMessage(options.errorMessage || "");
  }, [option, options]);

  const checkIfPresent = (id: number, opts: any[]) => {
    return option in opts
  };

  const deleteOption = () => {
    dispatch(deleteByValidationKey(option));
  };

  const checkValue = (key: string, prop: string): boolean => {
    switch (key) {
      case "min":
        const { max } = options;
        if (!!max) {
          return Number(options["max"]) > Number(prop);
        }
        return true;
      case "max":
        const { min } = options;
        if (!!min) {
          return Number(options["min"]) < Number(prop);
        }
        return true;
      case "minlength":
        const { maxlength } = options;
        if (!!maxlength) {
          return Number(options["maxlength"]) > Number(prop);
        }
        return true;
      case "maxlength":
        const { minlength } = options;
        if (!!minlength) {
          return Number(options["minlength"]) < Number(prop);
        }
        return true;
      case "pattern":
        return prop.length > 0 ? true : false;
      default:
        return true;
    }
  };

  const editOption = () => {
    if (isEdit) {
      const labelPresent = checkIfPresent(option, options);
      if (checkValue(option, value)) {
        setErrMessage("");
        if (label && value && labelPresent) {
          const updatedOptions = { ...options };
          updatedOptions[option] = value;
          updatedOptions["errorMessage"] = errorMessage;
          props.updateOptions(
            updatedOptions[option],
            `properties.validation.${option}`
          );
          setEdit(!isEdit);
        }
      } else {
        if (option !== "pattern") {
          setErrMessage(getErrorMessage(option));
        }
      }
    } else {
      setEdit(!isEdit);
    }
  };

  const getErrorMessage = (errLabel: string): string => {
    switch (errLabel) {
      case "min":
        return "Min value should be lesser than max value";
      case "max":
        return "Max value should be greater than min value";
      case "minlength":
        return "Min-length should be less than max-length";
      case "maxlength":
        return "Max-length should be greater than min-length";
      default:
        return "Error";
    }
  };

  const validationlengthinput = {
    width: "120px",
    height: "28px",
    marginLeft: "12px",
    borderRadius: "2px !important",
  }

  return (
    <>
      <div className="grid grid-cols-4 gap-0 m-2 items-center">
        <label
          style={{ fontSize: "12px", width: "65px" }}
          className="block col-span-1 mt-2 text-lg text-gray-900 dark:text-gray-300"
          htmlFor="validation"
        >
          {label}
        </label>
        <input
          style={validationlengthinput}
          type={"text" || "number"}
          className="shadow-sm  col-span-1 bg-white border border-gray-300 text-gray-900 text-lg block w-full p-2.5 cursor-pointer focus:outline-none"
          disabled={!isEdit || !canEdit}
          placeholder="Value"
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
          }}
        />
        {isEdit && canEdit ? (
          <SaveIcon
            data-test-id="validation_save"
            style={{ stroke: "#505F7B", marginLeft: "81px", width: "13px", height: "13px" }}
            className="h-7 w-7 items-center cursor-pointer"
            onClick={() => canEdit && editOption()}
          />
        ) : (
          <EditIcon
            data-test-id="validation_edit"
              style={{ stroke: "#505F7B", marginLeft: "81px", width: "13px", height: "13px" }}
            className="h-7 w-7 items-center cursor-pointer"
            onClick={() => canEdit && editOption()}
          />
        )}
        <DeleteIcon
          data-test-id="validation_delete"
          style={{ stroke: "#505F7B", marginLeft: "45px", width: "13px", height: "13px" }}
          className="h-7 w-7 items-center cursor-pointer"
          onClick={() => canEdit && deleteOption()}
        />
      </div>
      {ErrMessage && (
        <p
          data-test-id="validation_error_message"
          style={{ color: "red", textAlign: "left", marginTop: "10px" }}
        >
          {ErrMessage}
        </p>
      )}
    </>
  );
};
